import { FormInstance, Select } from "antd";
import { FC, useRef } from "react";
import { Form, FORM_FIELD_TYPES } from "site/ui";
import { courseCategoryLabelMap, ICourse } from "utils/types";

const { Option } = Select;
export interface CourseBasicFormProps {
    formRef: React.RefObject<FormInstance<ICourse>>
    // onGetForm: (form: FormInstance) => void;
    setFile: (file: File) => void;
    course?: ICourse;
    setCourseChanges?: (func: (courseChanges: Partial<ICourse>) => Partial<ICourse>) => void;
}
export const CourseBasicForm:FC<CourseBasicFormProps> = ({
    course, setCourseChanges, setFile, formRef
}) => {

    return (
        <Form
            formRef={formRef}
            items={[
                {
                  fieldType: FORM_FIELD_TYPES.UPLOAD,
                  itemProps: {
                    name: "image",
                    label: "Course Image",
                  },
                  fieldProps: {
                    dragProps: {
                        name: "file",
                        multiple: false,
                        action: "",
                        onChange(info: any) {
                          const { status } = info.file;
                          if (status !== "uploading") {
                            console.log(info.file, info.fileList);
                          }
                          if (status === "done") {
                            console.log(`${info.file.name} file uploaded successfully.`);
                          } else if (status === "error") {
                            console.error(`${info.file.name} file upload failed.`);
                          }
                          setFile(info.file.originFileObj);
                        },
                        onDrop(e: React.DragEvent<HTMLDivElement>) {
                          console.log("Dropped files", e.dataTransfer.files);
                          setFile(e.dataTransfer.files[0]);
                        },
                      accept: "image/*",
                    },
                    text: "Drag & drop course image, or click to browse files",
                    hint: "Supported formats: JPEG, PNG, GIF, WEBP...",
                  },
                },
                {
                  fieldType: FORM_FIELD_TYPES.SELECT,
                  itemProps: {
                    name: "category",
                    label: "Category",
                    rules: [{ required: true, message: "Please select a category" }],
                  },
                  fieldProps: {
                    placeholder: "Select category",
                    children: [
                      <Option key="medicalExams" value="medicalExams">
                        {courseCategoryLabelMap("medicalExams")}
                      </Option>,
                      <Option key="license" value="license">
                        {courseCategoryLabelMap("license")}
                      </Option>,
                      <Option key="others" value="others">
                        {courseCategoryLabelMap("others")}
                      </Option>,
                    ],
                  },
                },
                {
                  fieldType: FORM_FIELD_TYPES.TEXT,
                  itemProps: {
                    name: "title",
                    label: "Course title",
                    rules: [{ required: true, message: "Please enter a course title" }],
                  },
                  fieldProps: {
                    placeholder: "Enter course title",
                  },
                },
                {
                  fieldType: FORM_FIELD_TYPES.TEXT_AREA,
                  itemProps: {
                    name: "description",
                    label: "Course description",
                    rules: [
                      { required: true, message: "Please enter a course description" },
                    ],
                  },
                  fieldProps: {
                    placeholder: "Enter course description",
                    rows: 4,
                  },
                },
                {
                  fieldType: FORM_FIELD_TYPES.SELECT,
                  itemProps: {
                    name: "courseType",
                    label: "Course type",
                    rules: [{ required: true, message: "Please select a course type" }],
                  },
                  fieldProps: {
                    placeholder: "Select course type",
                    children: [
                      <Option key="free" value="free">
                        Free
                      </Option>,
                      <Option key="premium" value="premium">
                        Premium
                      </Option>,
                    ],
                  },
                },
              ]}
            formProps={{
                layout: "vertical",
                initialValues: course,
                onValuesChange(changedValues) {
                  setCourseChanges?.(prev => ({...prev, ...changedValues}))
                },
            }}
        />
    );
}